import { Layout, Spin } from 'antd';
import 'primeflex/primeflex.css';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './routes/ProtectedRoute';
import { getRoutes } from './routes/Routes';
import './styles/index.scss';
import LoadingOverlayWrapper from 'react-loading-overlay-ts';
import PublicLayout from './components/layout/Public';

const App = () => {
  const { token: authToken } = useSelector((state) => state.authSlice);
  const { loading } = useSelector((state) => state.loadingSlice);
  const { publicRoutes, protectedRoutes } = useMemo(() => {
    const allRoutes = Object.values(getRoutes());
    return {
      publicRoutes: allRoutes.filter((r) => r.public || r.global),
      protectedRoutes: allRoutes.filter((r) => !r.public || (!r.public && r.global)),
    };
  }, []);

  return (
    <LoadingOverlayWrapper
      spinner={<Spin fullscreen size="large" />}
      active={loading}
      styles={{
        overlay: (base) => ({
          ...base,
          background: 'rgba(255, 255, 255, 0.5)',
          height: '100vh',
          zIndex: 9999,
        }),
      }}
    >
      <Layout style={{ height: '100dvh', overflow: 'auto' }}>
        <Layout.Content>
          <Routes>
            {/* Public Routes */}
            {!authToken &&
              publicRoutes?.map((route) => (
                <Route
                  key={route.name}
                  path={route.path}
                  element={
                    <PublicLayout global={route?.global ?? false}>
                      <route.element />
                    </PublicLayout>
                  }
                />
              ))}

            {/* Protected Routes */}
            {authToken &&
              protectedRoutes?.map((route) => (
                <Route
                  key={route.name}
                  path={route.path}
                  element={
                    <ProtectedRoute allowedRoles={route.allowedRoles}>
                      <route.element />
                    </ProtectedRoute>
                  }
                />
              ))}

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout.Content>
      </Layout>
    </LoadingOverlayWrapper>
  );
};

export default App;
